import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-play-line',
  templateUrl: './icon-play-line.component.html',
  styleUrls: ['./icon-play-line.component.scss']
})
export class IconPlayLineComponent implements OnInit {
  @Input() color = '#262628';
  @Input() size = 18;

  constructor() { }

  ngOnInit() {
  }

}
